import React, { useEffect, useState } from 'react';
import './button.css';

const Button = ({ text, action, disabled, color, classNames, padding, fill }) => {
  const [colorState, setColorState] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setColorState(disabled && color ? `${color}-light` : color);
  }, [color, disabled]);

  const handleClick = (event) => {
    if (action && !disabled) {
      event.preventDefault();
      action();
    }
  };

  const handleMouseEnter = () => {
    setColorState(!disabled && color ? `${color}-hard` : colorState);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setColorState(disabled && color ? `${color}-light` : color);
    setIsHovered(false);
  };

  return (
    <button
      className={`fill-${fill
        ? colorState
        : !fill && isHovered
          ? colorState
          : `${disabled ? colorState : "White"}`
        } border-${!fill ? colorState : "none"} ${!padding ? "BigButton" : ""
        } ${"sorteo-button"} ${classNames}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}>
      {text}
    </button>
  );
}

export default Button;
